import React from 'react';
import { Button } from 'react-bootstrap';
import { connect } from "react-redux";
import { Field, reduxForm, formValueSelector } from 'redux-form';
import FormField from '../../forms/FormField';
import Loading from '../../ui/Loading';

const required = value => value ? undefined : 'Required';

const VerifyAddressForm = (
    {
        handleSubmit,
        AddressBook,
        selectedAddressValue,
        lookups,
        onCancel,
        inProgress
    }
) => {
    const options = [{ label: 'Add Address', value: 'addaddress' }]
        .concat((AddressBook || []).map((address) => {
            const { Address1, Address2, City, StateShort, Zip, AddressBookID } = address;
            return { value: AddressBookID, label: `${Address1} ${Address2 || ''}, ${City} ${StateShort}, ${Zip}` }
        }))
    const { states } = lookups || {};
    const stateOptions = (states || []).map(({ stateId, stateName }) => ({ value: stateId, label: stateName }))
    return (
        <form onSubmit={handleSubmit}>
            <h3>Default Club Address</h3>
            <div>
                <Field
                    placeholder="Select or Add Address"
                    name="selectedAddress"
                    type="text"
                    component={FormField.SelectReact}
                    options={options}
                    validate={[required]}
                />
                {
                    selectedAddressValue === 'addaddress' &&
                    <>
                        <div>
                            <div className='form-row'>
                                <div className='col-md-6'>
                                    <Field
                                        name="firstName"
                                        type="text"
                                        component={FormField.Input}
                                        placeholder="First Name"
                                        validate={[required]}
                                    />
                                </div>

                                <div className='col-md-6'>
                                    <Field
                                        name="lastName"
                                        type="text"
                                        component={FormField.Input}
                                        placeholder="Last Name"
                                        validate={[required]}
                                    />
                                </div>

                            </div>
                            <div className="form-row">
                                <div className="col-md-9">
                                    <Field
                                        name="address1"
                                        type="text"
                                        component={FormField.Input}
                                        placeholder="Address"
                                        validate={[required]}
                                    />
                                </div>
                                <div className="col-md-3">
                                    <Field
                                        name="address2"
                                        type="text"
                                        component={FormField.Input}
                                        placeholder="Apt/Suite"
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="form-row">
                            <div className="col-md-4">
                                <Field
                                    name="city"
                                    type="text"
                                    component={FormField.Input}
                                    placeholder="City"
                                    validate={[required]}
                                />
                            </div>
                            <div className="col-md-4">
                                <Field
                                    name="stateId"
                                    type="text"
                                    component={FormField.SelectReact}
                                    placeholder="State"
                                    validate={[required]}
                                    options={stateOptions}
                                />
                            </div>
                            <div className="col-md-4">
                                <Field
                                    name="zip"
                                    type="text"
                                    component={FormField.Input}
                                    placeholder="Zip"
                                    validate={[required]}
                                />
                            </div>
                        </div>
                    </>

                }
                <div>
                    <div className="form-row">
                        <div className="col-md-3 form-group">
                            <button
                                type="submit"
                                className="btn btn-primary btn-block"
                                disabled={inProgress}>
                                Save
                            </button>
                        </div>
                        <div className="col-md-3">
                            <button
                                type="button"
                                className="btn btn-inverse btn-block"
                                onClick={() => onCancel('VerifyAddressModal')}
                                disabled={inProgress}
                            >
                                Cancel
                            </button>
                        </div>
                        {
                            inProgress &&
                            <div className='col-md-3'>
                                <Loading />
                            </div>
                        }

                    </div>
                </div>
            </div>

        </form>
    )
}

const formName = 'verify-address-form';
const selector = formValueSelector(formName);
const mapState = state => {
    const selectedAddressValue = selector(state, 'selectedAddress') || null;
    return {
        selectedAddressValue
    }
}
const form = reduxForm({ form: formName, enableReinitialize: true })(VerifyAddressForm);
export default connect(mapState)(form);